import { get, post } from "../../helpers/api_helper";

// Fetch Purpose only when exporting. Omit summaryId to export all PPPs.
export const GetPPPExportDetails = async (orgId, branchId, userId, summaryId = null) => {
    const params = new URLSearchParams({
        Id: "1", orgid: String(orgId), BranchId: String(branchId),
        UserId: String(userId), opt: "2"
    });
    if (summaryId !== null) {
        const id = Number(summaryId);
        if (!Number.isSafeInteger(id) || id <= 0) throw new Error("Invalid PPP SummaryId.");
        params.set("summaryId", String(id));
    }
    const res = await get(`/PeriodicPaymentPlan/GetAll?${params.toString()}`);
    if (!res?.status || !Array.isArray(res.data)) {
        throw new Error(res?.message || "Unable to load PPP export data.");
    }
    return res.data;
};

/**
 * PPP API - Uses .NET Backend
 */

// Get all PPP details
export const GetPaymentPalnAccordianDetails = async (id, orgId, branchId, userid) => {
    try {
        const res = await get(
            `/PeriodicPaymentPlan/GetAll?Id=${id}&orgid=${orgId}&BranchId=${branchId}&UserId=${userid}`
        );
        // Helper usually returns response.data directly, but verify usage in other files
        return res;
    } catch (error) {
        console.error("Failed to fetch PPP details", error);
        return { status: false, message: error.message };
    }
};

// Save/Create PPP Voucher
export const SaveVoucherAPI = async (payload) => {
    try {
        console.log("Sending payload:", payload);
        const response = await post(
            `/PeriodicPaymentPlan/Create`,
            payload
        );
        return response;
    } catch (error) {
        console.error('Save Voucher Error:', error);
        throw error;
    }
};

// Get Payment Voucher
export const GetPaymentVoucher = async (voucherid, orgId, branchId) => {
    try {
        const res = await get(
            `/PeriodicPaymentPlan/GetVoucher?VoucherId=${voucherid}&orgid=${orgId}&BranchId=${branchId}`
        );
        return res;
    } catch (error) {
        console.error("Failed to fetch payment voucher", error);
        return { status: false, message: error.message };
    }
};
